import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const LoginCallback = () => {
  const { loading, isAuthenticated, error: authError, session } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    if (loading) return;

    if (isAuthenticated) {
      let returnUrl = localStorage.getItem('auth_redirect_url');
      const searchParams = new URLSearchParams(location.search);

      if (searchParams.has('returnUrl')) {
        returnUrl = searchParams.get('returnUrl');
      }

      if (session?.state) {
        try {
          const stateData = JSON.parse(session.state);

          if (stateData && stateData.returnUrl) {
            returnUrl = stateData.returnUrl;
          }
        } catch {
          // ignore malformed state
        }
      }

      if (!returnUrl) returnUrl = '/';
      localStorage.removeItem('auth_redirect_url');
      navigate(returnUrl, { replace: true });
    } else {
      setLocalError(authError || 'Authentication failed. Please try logging in again.');
    }
  }, [loading, isAuthenticated, navigate, authError, location, session]);

  if (loading) {
    return (
      <div className="login-callback-container">
        <h2>Processing Login</h2>
        <p className="status-message">Verifying authentication...</p>
      </div>
    );
  }

  if (localError) {
    return (
      <div className="login-callback-container">
        <h2>Authentication Failed</h2>
        <p className="error-message">{localError}</p>
        <button onClick={() => navigate('/login')} className="login-submit-button">
          Try Login Again
        </button>
      </div>
    );
  }

  return (
    <div className="login-callback-container">
      <h2>Redirecting...</h2>
    </div>
  );
};

export default LoginCallback;
